import React from "react";
import { Box } from "@mui/material";

const EdgeCameraControls = ({
  edgeHover,
  edgeControlWidth,
  edgeControlHeight,
  rotateCamera,
}) => {
  return (
    <>
      <Box
        className="edge-zone edge-zone-left"
        sx={{
          position: "absolute",
          top: "var(--app-header-height, 0px)",
          left: 0,
          width: edgeControlWidth,
          height: "calc(100% - var(--app-header-height, 0px))",
          zIndex: 15,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          pointerEvents: edgeHover.left ? "auto" : "none",
        }}
      >
        <Box
          className="edge-button"
          component="button"
          type="button"
          aria-label="Rotate camera left"
          onClick={(event) => {
            event.stopPropagation();
            rotateCamera("-4,0");
          }}
          sx={{
            width: edgeControlWidth,
            height: "100%",
            border: "none",
            borderRadius: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            color: "#fff",
            opacity: edgeHover.left ? 1 : 0,
            transition: "opacity 200ms ease, background-color 200ms ease",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "18px",
            "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.45)" },
          }}
        >
          {"◀"}
        </Box>
      </Box>

      <Box
        className="edge-zone edge-zone-right"
        sx={{
          position: "absolute",
          top: "var(--app-header-height, 0px)",
          right: 0,
          width: edgeControlWidth,
          height: "calc(100% - var(--app-header-height, 0px))",
          zIndex: 15,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          pointerEvents: edgeHover.right ? "auto" : "none",
        }}
      >
        <Box
          className="edge-button"
          component="button"
          type="button"
          aria-label="Rotate camera right"
          onClick={(event) => {
            event.stopPropagation();
            rotateCamera("4,0");
          }}
          sx={{
            width: edgeControlWidth,
            height: "100%",
            border: "none",
            borderRadius: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            color: "#fff",
            opacity: edgeHover.right ? 1 : 0,
            transition: "opacity 200ms ease, background-color 200ms ease",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "18px",
            "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.45)" },
          }}
        >
          {"▶"}
        </Box>
      </Box>

      <Box
        className="edge-zone edge-zone-top"
        sx={{
          position: "absolute",
          top: "var(--app-header-height, 0px)",
          left: 0,
          width: "100%",
          height: edgeControlHeight,
          zIndex: 15,
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          pointerEvents: edgeHover.top ? "auto" : "none",
        }}
      >
        <Box
          className="edge-button"
          component="button"
          type="button"
          aria-label="Rotate camera up"
          onClick={(event) => {
            event.stopPropagation();
            rotateCamera("0,2");
          }}
          sx={{
            width: "100%",
            height: edgeControlHeight,
            border: "none",
            borderRadius: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            color: "#fff",
            opacity: edgeHover.top ? 1 : 0,
            transition: "opacity 200ms ease, background-color 200ms ease",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "18px",
            "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.45)" },
          }}
        >
          {"▲"}
        </Box>
      </Box>

      <Box
        className="edge-zone edge-zone-bottom"
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: edgeControlHeight,
          zIndex: 15,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          pointerEvents: edgeHover.bottom ? "auto" : "none",
        }}
      >
        <Box
          className="edge-button"
          component="button"
          type="button"
          aria-label="Rotate camera down"
          onClick={(event) => {
            event.stopPropagation();
            rotateCamera("0,-2");
          }}
          sx={{
            width: "100%",
            height: edgeControlHeight,
            border: "none",
            borderRadius: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            color: "#fff",
            opacity: edgeHover.bottom ? 1 : 0,
            transition: "opacity 200ms ease, background-color 200ms ease",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "18px",
            "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.45)" },
          }}
        >
          {"▼"}
        </Box>
      </Box>
    </>
  );
};

export default EdgeCameraControls;
